import { t as _objectSpread2 } from "./objectSpread2-BNmiQYyW.js";
import { t as DocSearchButton } from "./DocSearchButton-CaxxOzQU.js";
import { t as _objectWithoutProperties } from "./objectWithoutProperties-phqYxDS0.js";
import { t as DocSearchAskAiModal } from "./DocSearchAskAiModal-ByqIW5ZA.js";
import { DocSearch, useDocSearch } from "@docsearch/core";
import React from "react";
import { createPortal } from "react-dom";

//#region src/DocSearchAI.tsx
const _excluded = ["appId", "apiKey"];
function DocSearchAIComponent(_ref, ref) {
	let { appId, apiKey } = _ref, props = _objectWithoutProperties(_ref, _excluded);
	return /* @__PURE__ */ React.createElement(DocSearch, _objectSpread2(_objectSpread2({}, props), {}, {
		appId,
		apiKey,
		ref
	}), /* @__PURE__ */ React.createElement(DocSearchAIInner, props));
}
const DocSearchAI = React.forwardRef(DocSearchAIComponent);
function DocSearchAIInner(props) {
	var _props$translations, _props$translations2, _props$portalContaine;
	const { searchButtonRef, keyboardShortcuts, isModalActive, isAskAiActive, initialQuery, onAskAiToggle, openModal, closeModal, isHybridModeSupported, appId, apiKey } = useDocSearch();
	if (!appId || !apiKey) throw new Error("`DocSearchAI` requires `appId` and `apiKey` props.");
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DocSearchButton, {
		keyboardShortcuts,
		ref: searchButtonRef,
		translations: (_props$translations = props.translations) === null || _props$translations === void 0 ? void 0 : _props$translations.button,
		onClick: openModal
	}), isModalActive && createPortal(/* @__PURE__ */ React.createElement(DocSearchAskAiModal, _objectSpread2(_objectSpread2({}, props), {}, {
		appId,
		apiKey,
		initialScrollY: window.scrollY,
		initialQuery,
		translations: props === null || props === void 0 || (_props$translations2 = props.translations) === null || _props$translations2 === void 0 ? void 0 : _props$translations2.modal,
		isAskAiActive,
		isHybridModeSupported,
		onAskAiToggle,
		onClose: closeModal
	})), (_props$portalContaine = props.portalContainer) !== null && _props$portalContaine !== void 0 ? _props$portalContaine : document.body));
}

//#endregion
export { DocSearchAI, DocSearchAIInner };
//# sourceMappingURL=docsearchAi.js.map